var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner[data-v-0ffe6a72]{background:url(" + escape(require("../../../../assets/img/banner-bg.jpg")) + ");background-size:cover;background-position:0}", ""]);

// exports
